import { ShareButtonSecondary } from 'components/common-form/sidePanel/docToolbar/summary/ShareButtonSecondary';
import { ConnectedPriceAdjustment } from 'components/secondaryMarket/live/sidePanel/quoted/priceAdjustement/PriceAdjustment.connect';
import type { QuotedExpiredSidePanelProps } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedExpiredSidePanel.connect';
import { ConnectedQuotedTabsPanel } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedTabPanel.connect';
import { RepriceQuoteButton } from 'components/secondaryMarket/live/sidePanel/quoted/RepriceQuoteButton';
import { ConnectedTradeWay } from 'components/secondaryMarket/shared/SidePanel/TradeWay.connect';
import { ActionButton, ButtonPanel, Price } from 'components/secondaryMarket/shared/status';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { FormattedMessage } from 'react-intl';

import { FlexColumnPanel } from '../../../shared/SidePanel/FlexColumnPanel';

export function QuotedExpiredSidePanel({
  onDone,
  onReprice,
  price,
  priceCurrency,
  priceType,
  formId,
}: QuotedExpiredSidePanelProps) {
  return (
    <FlexColumnPanel>
      <PanelHeader color="warning" discreet>
        <div className="d-flex justify-content-between">
          <ConnectedTradeWay formId={formId} />
          <ShareButtonSecondary
            tabId={formId}
            color="previous"
            mustForceAdvancedMode={false}
            workspaceType="secondaryMarketQuotes"
            type="live"
          />
        </div>
        <FormattedMessage id="secondaryMarket.sidePanel.label.settlementPrice" />
        <Price price={price} priceType={priceType} priceCurrency={priceCurrency} strikethrough />
      </PanelHeader>
      <PanelFooter color="warning" statusKey="sidePanel.label.expired" icon="schedule" className="rounded-bottom-3">
        <RepriceQuoteButton tabId={formId} />
      </PanelFooter>
      <ConnectedPriceAdjustment formId={formId} readonly={true} />
      <ConnectedQuotedTabsPanel formId={formId} />
      <ButtonPanel>
        <div className="btn-group my-1 w-100">
          <ActionButton color="discreet-secondary" label="secondaryMarket.sidePanel.cta.cancel" onClick={onDone} />
          <ActionButton
            color="default"
            label="secondaryMarket.sidePanel.cta.reprice"
            onClick={onReprice}
            icon="refresh"
          />
        </div>
      </ButtonPanel>
    </FlexColumnPanel>
  );
}
QuotedExpiredSidePanel.displayName = 'QuotedExpiredSidePanel';
